import { SITE_NAME } from "../config/AppConfig";
import { useLanguage } from "../context/LanguageContext";

const VendorFooter = () => {
    const { selectedLanguage, changeLanguage, langJson } = useLanguage();
    return (
        <div className="dashFooter">
            <h3>
                {langJson?.copyright} © {SITE_NAME} {new Date().getFullYear()}
            </h3>
        </div>
    );
}
export default VendorFooter;
